import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import useSegmentPng2x from './assets/UseSegment@2x.png'
import useSegmentWebp from './assets/UseSegment.webp'
import useSegmentWebp2x from './assets/UseSegment@2x.webp'

const UseSegmentImage = () => {
  return (
    <Picture>
      <source type="image/webp" srcSet={`${useSegmentWebp}, ${useSegmentWebp2x} 2x`} />
      <Image src={useSegmentPng2x} alt="Illustration: Segment integrations" width="941" height="804" loading="lazy" />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default UseSegmentImage
